const state = {
    interventionTypes: [],
    interventionStatus: []
}

const getters = {
    interventionTypes: (state) => state.interventionTypes,
    interventionStatus: (state) => state.interventionStatus
};

const actions = {
    setInterventionTypes({commit}, data) {
        commit('setInterventionTypesMut', data)
    },

    setInterventionStatus({commit}, data) {
        commit('setInterventionStatusMut', data)
    }
}

const mutations = {
    setInterventionTypesMut(state, data) {
        state.interventionTypes = data
    },

    setInterventionStatusMut(state, data) {
        state.interventionStatus = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/globalVariable.js